import { AssistantMessage, UserMessage } from './messages';

import type { MessageState } from '@assistant-ui/react';

// System messages render nothing, which is what the `components` prop this
// replaced did when no `SystemMessage` was supplied.
export function renderMessage({ message }: { message: MessageState }) {
  if (message.role === 'user') return <UserMessage />;
  if (message.role === 'assistant') return <AssistantMessage />;
  return null;
}
